import { useTranslation } from "react-i18next";
import { useReservationFormat } from "../../../../reservations/hooks/useReservationFormat";
import type { SeatTiming } from "./seatReservationGroups";

/** Преведените форми на „Настани": маси и статус спрямо „сега". */
export const useSeatFormat = () => {
  const { t } = useTranslation();
  const format = useReservationFormat();

  /** „Маса 4" / „Маси 10, 9". */
  const tables = (names: string[]) =>
    t("seatReservation.tables", { count: names.length, tables: names.join(", ") });

  /** В реда: „−36 мин" / „след 9 мин" / „сега". */
  const timingShort = (timing: SeatTiming) =>
    timing.kind === "late"
      ? t("seatReservation.lateShort", { duration: format.duration(timing.minutes) })
      : timing.kind === "soon"
        ? t("seatReservation.soonShort", { duration: format.duration(timing.minutes) })
        : t("seatReservation.now");

  return { tables, timingShort };
};
